<template>
  <div class="upload">
    <Uploader v-bind="Object.assign(itemArr, { multiple: false, afterRead: onsuccess })" accept="image/*" @oversize="$emit('oversize')">
      <slot>
        <div class="upload-content" :class="transCls">
          <img src="./bj.png" alt="" />
          <p style="margin-bottom: 0;">点击上传</p>
        </div>
      </slot>
    </Uploader>
  </div>
</template>

<script>
import Axios from "axios"
import { Uploader, Toast } from "vant"
import Config from "@/config/app.js"
import { getOssKey } from "@/api/components.js"
import canvasResize from "canvas-resize"
import { getOsVersion } from "@/utils/app.js"
import { isIphone } from "@/utils/isTerminal.js"

let ToastLoading

export default {
  name: "Upload",
  props: {
    dir: {
      type: String,
      default: "jkhh50test",
    },
    itemArr: {
      type: Object,
      default: function() {
        return {}
      },
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    transCls: String, // 传递类
  },
  data: function() {
    return {
      ossConfig: {
        name: "",
        key: "",
        policy: "",
        OSSAccessKeyId: "",
        signature: "",
        host: "",
        expire: "",
        success_action_status: 200, //让服务端返回200，不设置则默认返回204
      },
      ossFullName: "",
    }
  },
  components: { Uploader },
  methods: {
    onsuccess(file) {
      let imgType = file.file.type
      if (imgType == "image/jpg" || imgType == "image/png" || imgType == "image/jpeg") {
        this.uploadOssPicture(file)
      } else {
        return Toast("不支持该图片格式")
      }
      //this.$emit('uploadSuccess',this.ossFullName, file, fileList,response)
    },
    uploadOssPicture(file) {
        let mediaType = 1
        if (/image/.test(file.file.type)) {
            mediaType = 1
        } else if (/audio/.test(file.file.type) || /video/.test(file.type)) {
            mediaType = 2
        } else {
            mediaType = 3
        }
        getOssKey({ path: this.dir, mediaType: mediaType })
        .then((r) => {
          let fileName = r.fileName + "." + file.file.type.split("/")[1]
          this.ossConfig.name = fileName
          this.ossConfig.key = r.dir + "/" + fileName
          this.ossConfig.policy = r.policy
          this.ossConfig.OSSAccessKeyId = r.accessId
          this.ossConfig.signature = r.signature
          this.ossConfig.host = r.host
          this.ossConfig.expire = r.expire
          this.ossFullName = r.host + "/" + r.dir + "/" + fileName

          // iphone 版本 10.2.1 压缩有问题
          // let osVersion = getOsVersion();
          // if (isIphone && osVersion === '10.2.1') {
          //     this.uploadFile(file.file);
          //     return;
          // }

          this.uploadFile(file.file)
        })
        .catch((e) => {
          Toast("设置OSS配置出错！")
        })
    },
    uploadFile(Data) {
      ToastLoading = Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中...",
      })

      let formData = new FormData()

      for (let k in this.ossConfig) {
        formData.append(k, this.ossConfig[k])
      }
      formData.append("file", Data) //我靠，顺序有要求。
      Axios.post(this.ossConfig.host, formData, {
        timeout: Config.timeout,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((r) => {
          console.log("ossFullName", this.ossFullName)
          console.log("currentIndex", this.currentIndex)
          this.$emit("uploadSuccess", this.ossFullName, this.currentIndex)
          ToastLoading.clear()
        })
        .catch((e) => {
          console.log("uploadFile error", e)
        })
    },
    compress(file) {
      let that = this
      canvasResize(file, {
        crop: false,
        quality: 0.5,
        rotate: 0,
        callback(base64) {
          if (base64.length >= 10) {
            let onceFile = that.dataurlToFile(base64)
            that.uploadFile(onceFile)
          } else {
            Toast("图片异常，请重新上传")
          }
        },
      })
    },
    dataurlToFile(dataurl, filename = "image/png") {
      // base64 装 file
      let arr = dataurl.split(",")
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      //转换成file对象
      return new File([u8arr], filename, { type: mime })
    },
  },
}
</script>

<style scoped lang="scss">
.upload-content {
  width: 127px;
  height: 90px;
  background: #e3e5e9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.wh-one {
    width: 143px;
    height: 104px;
  }

  p {
    color: #69707f;
    font-size: 12px;
  }

  img {
    width: 31px;
    height: 26px;
  }
}
</style>
